import { motion } from "framer-motion";

/**
 * SectionFrame — decorative corner brackets + vertical guide lines
 * for the section it wraps. Use sparingly to add structure without noise.
 */
export function CornerMarks({ className = "" }) {
  const arm = 14;
  return (
    <>
      <svg
        aria-hidden="true"
        className={`absolute top-3 left-3 w-4 h-4 text-white/30 ${className}`}
      >
        <path d={`M0 ${arm} L0 0 L${arm} 0`} stroke="currentColor" strokeWidth="1" fill="none" />
      </svg>
      <svg
        aria-hidden="true"
        className={`absolute top-3 right-3 w-4 h-4 text-white/30 ${className}`}
      >
        <path d={`M${arm - arm} 0 L${arm} 0 L${arm} ${arm}`} stroke="currentColor" strokeWidth="1" fill="none" />
      </svg>
      <svg
        aria-hidden="true"
        className={`absolute bottom-3 left-3 w-4 h-4 text-white/30 ${className}`}
      >
        <path d={`M0 0 L0 ${arm} L${arm} ${arm}`} stroke="currentColor" strokeWidth="1" fill="none" />
      </svg>
      <svg
        aria-hidden="true"
        className={`absolute bottom-3 right-3 w-4 h-4 text-white/30 ${className}`}
      >
        <path d={`M${arm} 0 L${arm} ${arm} L0 ${arm}`} stroke="currentColor" strokeWidth="1" fill="none" />
      </svg>
    </>
  );
}

export function PlusMark({ className = "" }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={`text-white/20 ${className}`}
    >
      <path
        d="M12 2 L12 22 M2 12 L22 12"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function FloatingPlus({ x = "10%", y = "10%", size = 18, delay = 0, accent = false }) {
  return (
    <motion.div
      className="absolute pointer-events-none"
      style={{ left: x, top: y, width: size, height: size }}
      initial={{ opacity: 0, rotate: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-100px" }}
      animate={{ rotate: 360 }}
      transition={{
        opacity: { duration: 1, delay },
        rotate: { duration: 24, repeat: Infinity, ease: "linear" },
      }}
    >
      <PlusMark className={`w-full h-full ${accent ? "text-[var(--accent)]/40" : ""}`} />
    </motion.div>
  );
}
